<template>
  <div class="success">
    <div class="text">提交成功!</div>
    <div class="wait">{{ timeOut }}秒后自动跳转, 请您跳转后继续完善资料...</div>
    <div class="to"><a :href="url">如未自动跳转, 请手动点击此处跳转</a></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
      timeOut: 3
    };
  },
  methods: {
    openJinkong() {
      if (!this.url) {
        this.$router.go(-1);
      }
      let timer = setInterval(() => {
        this.timeOut--;
        if (this.timeOut <= 0) {
          clearInterval(timer);
          window.open(this.url);
        }
      }, 1000);
    }
  },
  created() {
    this.url = this.$route.query.url;
  },
  mounted() {
    this.openJinkong();
  }
};
</script>

<style lang="less" scoped="scoped">
.success {
  width: 1200px;
  margin: 0 auto;
  height: calc(60vh - 91px);
  min-height: 500px;
  max-height: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text {
    color: #00dd62;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .wait {
    font-size: 40px;
    color: rgb(41, 41, 41);
    font-weight: bold;
  }
  .to {
    a {
      text-decoration: revert;
      color: #59ab7e;
    }
  }
}
</style>
